var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	62045: () => (loadStrictSingletonVersion("default", "@angular/core", false, [1,17,3,11], () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	69203: () => (loadStrictSingletonVersion("default", "@angular/common", false, [1,17,3,11], () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	32778: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (__webpack_require__.e(8219).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	44866: () => (loadStrictSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	51599: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [1,17,3,11], () => (__webpack_require__.e(5689).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	91667: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [1,17,3,11], () => (__webpack_require__.e(8824).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	44870: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [1,17,3,11], () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	30062: () => (loadStrictSingletonVersion("default", "ngx-bootstrap/collapse", false, [1,12,0,0], () => (__webpack_require__.e(8751).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/collapse */ 18751))))))),
	9074: () => (loadStrictSingletonVersion("default", "ngx-bootstrap/utils", false, [1,12,0,0], () => (__webpack_require__.e(4722).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/utils */ 72341))))))),
	42873: () => (loadStrictSingletonVersion("default", "@angular/animations", false, [1,17,3,11], () => (__webpack_require__.e(4791).then(() => (() => (__webpack_require__(/*! @angular/animations */ 47172))))))),
	13154: () => (loadStrictSingletonVersion("default", "ngx-bootstrap/positioning", false, [1,12,0,0], () => (__webpack_require__.e(3282).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/positioning */ 40901))))))),
	3041: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [1,17,3,11], () => (__webpack_require__.e(2075).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))))),
	4196: () => (loadStrictSingletonVersion("default", "ngx-bootstrap/tooltip", false, [1,12,0,0], () => (__webpack_require__.e(6465).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/tooltip */ 36465))))))),
	4614: () => (loadStrictSingletonVersion("default", "ngx-bootstrap/timepicker", false, [1,12,0,0], () => (__webpack_require__.e(5768).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/timepicker */ 3387))))))),
	33967: () => (loadStrictSingletonVersion("default", "ngx-bootstrap/component-loader", false, [1,12,0,0], () => (__webpack_require__.e(3136).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/component-loader */ 70755))))))),
	76823: () => (loadStrictSingletonVersion("default", "ngx-bootstrap/chronos", false, [1,12,0,0], () => (__webpack_require__.e(4875).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/chronos */ 34875))))))),
	77428: () => (loadStrictSingletonVersion("default", "ngx-bootstrap/mini-ngrx", false, [1,12,0,0], () => (__webpack_require__.e(8813).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/mini-ngrx */ 38813))))))),
	7423: () => (loadStrictSingletonVersion("default", "ngx-bootstrap/focus-trap", false, [1,12,0,0], () => (__webpack_require__.e(3928).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/focus-trap */ 51547))))))),
	79383: () => (loadStrictSingletonVersion("default", "@angular/router", false, [1,17,3,11], () => (__webpack_require__.e(2691).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	76309: () => (loadStrictSingletonVersion("default", "jwt-decode", false, [1,4,0,0], () => (__webpack_require__.e(4751).then(() => (() => (__webpack_require__(/*! jwt-decode */ 34751))))))),
	91448: () => (loadStrictSingletonVersion("default", "aws-amplify", false, [1,6,0,17], () => (__webpack_require__.e(3677).then(() => (() => (__webpack_require__(/*! aws-amplify */ 36058))))))),
	56924: () => (loadStrictSingletonVersion("default", "@aws-sdk/client-cloudwatch-logs", false, [1,3,629,0], () => (__webpack_require__.e(5703).then(() => (() => (__webpack_require__(/*! @aws-sdk/client-cloudwatch-logs */ 28084))))))),
	16215: () => (loadStrictSingletonVersion("default", "ag-grid-angular", false, [4,33,3,0], () => (__webpack_require__.e(9672).then(() => (() => (__webpack_require__(/*! ag-grid-angular */ 27291))))))),
	64113: () => (loadStrictSingletonVersion("default", "ngx-autosize", false, [1,2,0,4], () => (__webpack_require__.e(1188).then(() => (() => (__webpack_require__(/*! ngx-autosize */ 68807))))))),
	32149: () => (loadStrictSingletonVersion("default", "ngx-bootstrap/datepicker", false, [1,12,0,0], () => (__webpack_require__.e(760).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/datepicker */ 98379))))))),
	68751: () => (loadStrictSingletonVersion("default", "ngx-bootstrap/tabs", false, [1,12,0,0], () => (__webpack_require__.e(7500).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/tabs */ 75119))))))),
	9906: () => (loadStrictSingletonVersion("default", "ngx-bootstrap/typeahead", false, [1,12,0,0], () => (__webpack_require__.e(7718).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/typeahead */ 35337))))))),
	21412: () => (loadStrictSingletonVersion("default", "ngx-currency", false, [1,17,0,0], () => (__webpack_require__.e(2215).then(() => (() => (__webpack_require__(/*! ngx-currency */ 7453))))))),
	37941: () => (loadStrictSingletonVersion("default", "ngx-mask", false, [1,17,0,4], () => (__webpack_require__.e(9150).then(() => (() => (__webpack_require__(/*! ngx-mask */ 86769))))))),
	10818: () => (loadStrictSingletonVersion("default", "angular-svg-icon", false, [1,17,0,0], () => (__webpack_require__.e(5694).then(() => (() => (__webpack_require__(/*! angular-svg-icon */ 3313))))))),
	44157: () => (loadStrictSingletonVersion("default", "ag-grid-enterprise", false, [4,33,3,0], () => (__webpack_require__.e(4596).then(() => (() => (__webpack_require__(/*! ag-grid-enterprise */ 69834))))))),
	60794: () => (loadStrictSingletonVersion("default", "ngx-bootstrap/modal", false, [1,12,0,0], () => (__webpack_require__.e(4838).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/modal */ 2457))))))),
	10616: () => (loadStrictSingletonVersion("default", "ngx-clipboard", false, [1,16,0,0], () => (__webpack_require__.e(9262).then(() => (() => (__webpack_require__(/*! ngx-clipboard */ 46881))))))),
	20101: () => (loadStrictSingletonVersion("default", "ngx-bootstrap/alert", false, [1,12,0,0], () => (__webpack_require__.e(7444).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/alert */ 95063))))))),
	92693: () => (loadStrictSingletonVersion("default", "@n5x-tech/platform-cnpj-validator", false, [3,0,0,2,,"beta",6], () => (__webpack_require__.e(3051).then(() => (() => (__webpack_require__(/*! @n5x-tech/platform-cnpj-validator */ 3051))))))),
	95558: () => (loadSingleton("default", "@n5x-tech/platform-feature-flags", false, () => (__webpack_require__.e(6740).then(() => (() => (__webpack_require__(/*! @n5x-tech/platform-feature-flags */ 94359))))))),
	72633: () => (loadStrictSingletonVersion("default", "ngx-bootstrap/accordion", false, [1,12,0,0], () => (__webpack_require__.e(2184).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/accordion */ 39803)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"436": [
		62045,
		69203,
		91667
	],
	"755": [
		9074,
		13154,
		62045,
		69203
	],
	"760": [
		4614,
		13154,
		32778,
		33967,
		77428
	],
	"901": [
		9074,
		44866,
		62045,
		69203
	],
	"1132": [
		42873,
		62045
	],
	"1194": [
		32778,
		44866
	],
	"1547": [
		32778,
		62045,
		69203
	],
	"1579": [
		72633
	],
	"2075": [
		32778,
		44866,
		69203
	],
	"2341": [
		62045
	],
	"2457": [
		7423,
		9074,
		13154,
		33967,
		62045
	],
	"2691": [
		32778
	],
	"3136": [
		9074,
		69203
	],
	"3282": [
		9074,
		44866,
		69203
	],
	"3313": [
		32778,
		44866,
		62045,
		69203,
		91667
	],
	"3387": [
		3041,
		44866,
		62045,
		69203,
		77428
	],
	"3928": [
		32778,
		69203
	],
	"4359": [
		32778,
		44866,
		62045,
		91667
	],
	"4456": [
		32778,
		44866,
		62045,
		69203
	],
	"4791": [
		69203
	],
	"4838": [
		7423,
		9074,
		13154,
		33967
	],
	"5020": [
		44870,
		62045,
		4196,
		69203,
		79383,
		76309,
		44866,
		91667,
		91448,
		56924,
		42873,
		3041,
		16215,
		64113,
		76823,
		32149,
		68751,
		9906,
		21412,
		37941,
		30062,
		10818,
		44157,
		60794
	],
	"5063": [
		9074,
		62045,
		69203
	],
	"5072": [
		32778,
		44866,
		44870,
		62045,
		69203
	],
	"5119": [
		62045,
		69203
	],
	"5337": [
		3041,
		9074,
		13154,
		32778,
		33967,
		42873,
		44866,
		62045,
		69203
	],
	"5694": [
		32778
	],
	"6443": [
		32778,
		44866,
		62045,
		69203
	],
	"6465": [
		9074,
		13154,
		33967
	],
	"6740": [
		32778
	],
	"6769": [
		3041,
		62045,
		69203
	],
	"6881": [
		44866,
		62045,
		69203
	],
	"6957": [
		32778
	],
	"7172": [
		62045,
		69203
	],
	"7291": [
		62045
	],
	"7444": [
		9074
	],
	"7453": [
		3041,
		62045
	],
	"7580": [
		32778,
		44866,
		51599
	],
	"7718": [
		9074,
		13154,
		32778,
		33967
	],
	"7935": [
		62045
	],
	"8055": [
		91667
	],
	"8379": [
		3041,
		4196,
		4614,
		13154,
		32778,
		33967,
		42873,
		44866,
		62045,
		69203,
		76823,
		77428
	],
	"8751": [
		42873
	],
	"8807": [
		62045
	],
	"8813": [
		32778
	],
	"8824": [
		32778,
		44866,
		69203
	],
	"8846": [
		9074,
		13154,
		33967,
		44866,
		62045,
		69203
	],
	"8951": [
		10616,
		20101,
		92693,
		95558
	],
	"9803": [
		30062,
		62045,
		69203
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}